import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getCatalogById } from '../../app/helpers/getCatalogById';
import { getObjectById } from '../../app/helpers/getObjectById';
import { getFieldInfo } from '../../app/helpers/getFieldInfo';
import { useTranslation } from 'react-i18next';
import "./tableComparison.css"

const TableHorizontalFullTechnology = ({ data }) => {
  const { t } = useTranslation();

  // Selectores de Redux
  const { listFieldsTechnology } = useSelector((state) => state.moduleConfig);
  const { listFullCatalogs } = useSelector((state) => state.catalog);
  const { listFullCatalogCiius } = useSelector((state) => state.catalogCiiu);
  const { listContinents, listFullRegions, listFullCountries } = useSelector((state) => state.locationCountry);

  // 1. Filtrar datos una sola vez
  //const comparedData = useMemo(() => data.filter(dta => dta.isCompared), [data]);
  const comparedData = useMemo(() => data.filter(dta => dta.isSelected), [data]);
  const comparableFields = useMemo(() => listFieldsTechnology.filter(f => f.is_comparable), [listFieldsTechnology]);

  // 2. Helper de resolución de texto (Refactorizado)
  const resolveCellValue = (fieldKey, dataObject) => {
    const fieldFound = getFieldInfo(fieldKey, listFieldsTechnology);
    if (!fieldFound || !fieldFound.is_comparable) return null;

    const val = dataObject[fieldKey];
    const condition = fieldFound.comparable_relation_condition;

    // Mapa de resolutores para evitar el "if-else hell"
    const resolvers = {
      "Fields": () => val,
      "Catalogs": () => getCatalogById(val, listFullCatalogs)?.description,
      "CatalogCiius": () => getObjectById(val, listFullCatalogCiius)?.name,
      "CatalogSections": () => getObjectById(val, listFullCatalogCiius)?.name,
      "CatalogPhases": () => getObjectById(val, listFullCountries)?.name,
      "CatalogCountries": () => getObjectById(val, listFullCountries)?.name,
      "CatalogRegions": () => getObjectById(val, listFullRegions)?.name,
      "CatalogContinents": () => getObjectById(val, listContinents)?.name,
      "Year": () => val ? new Date(val).getFullYear() : '',
    };

    return resolvers[condition] ? resolvers[condition]() : null;
  };

  return (
    <div className='table-horizontal-scroll-full'>
      <table className='table table-comparison'>
        <thead>
          <tr>
            {/* Esquina superior izquierda vacía y fija */}
            <th className="sticky-corner" style={{ left: 0, zIndex: 11 }}>
              {t('general.table.header.common.fields')}
            </th> 
            {comparedData.map((dta) => (
              <th key={`h-${dta.id}`} scope="col">
                <div className="text-primary">{dta.id}</div>
                <small className="text-muted">{dta.code}</small>
              </th>
            ))}
          </tr>
        </thead>
        
        <tbody>
          {comparableFields.map((fieldItem) => (
            <tr key={`row-${fieldItem.field}`}>
              {/* Etiqueta del campo fija a la izquierda */}
              <th scope="row">
                {t(`${fieldItem.module_text}.synthetic.${fieldItem.field}`)}
              </th>
              {comparedData.map((dta) => (
                <td key={`cell-${fieldItem.field}-${dta.id}`}>
                  {resolveCellValue(fieldItem.field, dta) || (
                    <span className="text-muted small">---</span>
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableHorizontalFullTechnology;
